const areObjectChildrenUndefined = (obj: object): boolean =>
    Object.values(obj).every((value) => {
        if (typeof value === 'object' && value !== null) {
            return areObjectChildrenUndefined(value)
        } else if (value) {
            return false
        } else {
            return true
        }
    })

const convertEmptyValuesToUndefined = (obj: any, parentObjToUndefined?: boolean): any => {
    const clone: any = {}
    Object.keys(obj).forEach((key) => {
        const value = obj[key]
        if (typeof value === 'object' && value !== null) {
            clone[key] = convertEmptyValuesToUndefined(value)
        } else if (Array.isArray(obj)) {
            clone[key] = obj.map((item) => convertEmptyValuesToUndefined(item))
        } else if (typeof value === 'string' && value.length === 0) {
            clone[key] = undefined
        } else if (Object.getOwnPropertyDescriptor(obj, key)) {
            clone[key] = value
        }
    })
    if (!!parentObjToUndefined && areObjectChildrenUndefined(clone)) {
        return undefined
    }
    return clone
}

export default convertEmptyValuesToUndefined
